import { useEffect, useRef } from "react";

export const useFetchSubscribedUsers = ({
                                            isAuth,
    perPage,
                                            getSubscribedUsers,
                                        }: {
    isAuth: boolean;
    perPage: number;
    getSubscribedUsers: (p: { page: number; perPage: number }) => void;
}) => {
    const didFetchRef = useRef(false);

    useEffect(() => {
        if (!isAuth) return;

        if (didFetchRef.current) return;
        didFetchRef.current = true;
        getSubscribedUsers({ page: 1, perPage });
    }, [isAuth, perPage, getSubscribedUsers]);
};
